function addClassActive(item) {
	item.classList.toggle('_active');
}
function addClassActiveTimer(item,time) {
	setTimeout(()=>{
		item.classList.toggle('_active');
	}, time);
}

let searchButton = document.querySelector('.menu__search');
let menuButton = document.querySelector('.menu__btn');
let searchInput = document.querySelector('.menu__input-search');
let arrLinks = document.querySelectorAll('.menu__link');

// Появление списков меню
menuButton.addEventListener("click", function (e) {
	if (arrLinks[0].classList.contains('_active')) {		
		for (let index = arrLinks.length-1; index >= 0; index--) {
			const element = arrLinks[index];
			addClassActiveTimer(element, (index-4)*-1*200);
		}
	} else {
		for (let index = 0; index < arrLinks.length; index++) {
			const element = arrLinks[index];
			addClassActiveTimer(element, (index+1)*200);
		}
	}	
}); 

// Делегирование
document.addEventListener("click", function (e) {	
	if (event.target.closest('.menu__form')) {
		if (event.target.closest('.menu__search')) {
			if (searchInput.classList.contains('_active')) {
				alert("The inquiry has been sent / Запрос отправлен");
			}
			else addClassActive(searchInput);
		}
	} else searchInput.classList.remove('_active');
});

document.addEventListener("keyup", function (event) {
	if (event.code == 'Escape') {
		searchInput.classList.remove('_active');
	}
});